/** An image field: the thumbnail and "Clear". Choosing an image waits for open point 4. */
import { Button } from '@codex/ui';
import type { EditorProps } from './shared.js';

export function ImageEditor({
  field,
  value,
  error,
  commit,
  readOnly,
}: EditorProps & { readonly readOnly?: boolean }) {
  const assetId = typeof value === 'string' && value !== '' ? value : null;
  return (
    <div className="cx-pills__field">
      <span className="cx-pills__label">{field.label}</span>
      {assetId === null ? (
        <span className="cx-pills__hint">No image.</span>
      ) : (
        <>
          <img
            className="cx-pills__thumb"
            src={`/files/${encodeURIComponent(assetId)}?variant=thumb`}
            alt={field.label}
          />
          {!readOnly && (
            <Button size="sm" onClick={() => commit('')}>
              Clear
              <span className="cx-visually-hidden"> {field.label}</span>
            </Button>
          )}
        </>
      )}
      {error !== null && <span className="cx-pills__error">{error}</span>}
    </div>
  );
}
